import * as Sentry from '@sentry/angular';
import type { ErrorEvent as SentryErrorEvent, EventHint } from '@sentry/core';
import { Environment } from '@micro-core/environment';

export class PerformanceTrackingConfigure {
  constructor() {}

  public setUpConfig(environment: Environment) {
    Sentry.init({
      dsn: environment.performance.sentry.dsn,
      environment: environment.performance.sentry.environment,
      release: environment.appVersion || window.location.hostname.split('.')[1],
      integrations: [
        Sentry.browserTracingIntegration({
          instrumentNavigation: true,
        }),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
        Sentry.extraErrorDataIntegration(),
        Sentry.httpClientIntegration()
      ],

      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      enableLogs: true,
      beforeSend(event: SentryErrorEvent, hint: EventHint) {
        const originalException = hint?.originalException as any;

        if (originalException?.code === 'remoteconfig/fetch-client-network') {
          Sentry.logger.warn('remoteconfig_fetch_client_network', {
            message: originalException?.message || 'Unknown error',
            code: originalException?.code,
          });
          return null;
        }

        // Realtime Remote Config stream can fail when backend is unreachable (e.g. firewall, offline).
        // App still has config from initial fetchAndActivate(); only live updates are affected.
        if (originalException?.code === 'remoteconfig/stream-error') {
          Sentry.logger.warn('remoteconfig_stream_error', {
            message: originalException?.message || 'Unknown error',
            code: originalException?.code,
          });
          return null;
        }

        const message =
          originalException?.message ??
          (typeof originalException === 'string' ? originalException : undefined);

        if (typeof message === 'string' && message.includes('remoteconfig/fetch-client-network')) {
          Sentry.logger.warn('remoteconfig_fetch_client_network', {
            message: message,
          });
          return null;
        }

        if (
          typeof message === 'string' &&
          (message.includes('remoteconfig/stream-error') ||
            message.includes('stream was not able to connect'))
        ) {
          Sentry.logger.warn('remoteconfig_stream_error', { message });
          return null;
        }

        return event;
      },
    });
  }
}
